<template>
	<v-ons-page>
		<ons-toolbar>
			<div class="left"><ons-back-button></ons-back-button></div>
			<div class="center">Back</div>
			<div v-if="false" class="right">
				<v-ons-toolbar-button slot="right" modifier="white-content" @click="showFilter = true">
					<v-ons-icon icon="md-edit"></v-ons-icon>
				</v-ons-toolbar-button>
			</div>
		</ons-toolbar>

		<div class="profile-top">
			<div v-if="welcomeImage" class="qf-user-welcome-avatar rounded">
				<img :src="welcomeImage" class="login-logo">
			</div>
			<div class="qf-lock-username">
				<h4>{{names}}</h4>
			</div>
			<v-ons-button class="button-margin" @click="goToCPW">Change password</v-ons-button>
		</div>

		<v-ons-list class="qf-label-data">
			<v-ons-list-header>Account Information</v-ons-list-header>
			<v-ons-list-item>
				<div class="left">Account E-Mail:</div>
				<div class="center">{{profile.email}}</div>
			</v-ons-list-item>
			<v-ons-list-item>
				<div class="left">Username: </div>
				<div class="center">{{profile.username}}</div>
			</v-ons-list-item>
			<v-ons-list-item>
				<div class="left">Account phone: </div>
				<div class="center">{{profile.phone}}</div>
			</v-ons-list-item>
			<v-ons-list-item v-if="profile.second_phone">
				<div class="left">Backup phone: </div>
				<div class="center">{{profile.second_phone}}</div>
			</v-ons-list-item>
		</v-ons-list>
		<v-ons-list class="qf-label-data" v-if="compProfilePrivateBlock">
			<v-ons-list-header>Private Information</v-ons-list-header>
			<v-ons-list-item v-if="profile.contact">
				<div class="left">Birthday: </div>
				<div class="center">{{profile.contact.date_of_birth}}</div>
			</v-ons-list-item>
			<v-ons-list-item v-if="profile.contact">
				<div class="left">Place of birth: </div>
				<div class="center">{{profile.contact.place_of_birth}}</div>
			</v-ons-list-item>
			<v-ons-list-item v-if="profile.contact">
				<div class="left">Private address: </div>
				<div class="center">{{profile.contact.private_address}}</div>
			</v-ons-list-item>
		</v-ons-list>
		<v-ons-list class="qf-label-data" v-if="profilePublicBlock">
			<v-ons-list-header>Public Information</v-ons-list-header>
			<v-ons-list-item v-if="profile.contact.bio">
				<div class="left">Quick bio: </div>
				<div class="center">
					<div v-html="profile.contact.bio"></div>
				</div>
			</v-ons-list-item>
			<v-ons-list-item v-if="profile.contact.organization">
				<div class="left">Organization: </div>
				<div class="center">{{profile.contact.organization}}</div>
			</v-ons-list-item>
			<v-ons-list-item v-if="profile.contact.email">
				<div class="left">E-mail: </div>
				<div class="center">{{profile.contact.email}}</div>
			</v-ons-list-item>
			<v-ons-list-item v-if="profile.contact.phone">
				<div class="left">Phone: </div>
				<div class="center">{{profile.contact.phone}}</div>
			</v-ons-list-item>
			<v-ons-list-item v-if="profile.contact.skype">
				<div class="left">Skype ID: </div>
				<div class="center">{{profile.contact.skype}}</div>
			</v-ons-list-item>
			<v-ons-list-item v-if="profile.contact.address">
				<div class="left">Correspondence Address: </div>
				<div class="center">{{profile.contact.address}}</div>
			</v-ons-list-item>
		</v-ons-list>
	</v-ons-page>
</template>

<script>
	import Api from '@/services/api';
	import ChangePassword from "./ChangePassword";
	//import DashboardHome from "../dashboard/DashboardHome";
	import Login from "../login/Login";
	import CollectionsHome from "../collections/CollectionsHome";
	export default {
		name: "MyProfile",
		data() {
			return {
				profile: {
					contact: {
						date_of_birth: null,
						place_of_birth: null,
						private_address: null,
						bio: null,
						organization: null,
						email: null,
						phone: null,
						skype: null,
						address: null
					}
				},
				profilePrivateBlock : true,
				profilePublicBlock : true
			}
		},
		mounted() {
			let self = this;
			Api().get('user/profile').then(response => {
				self.profile = response.data;
				console.log("Profile data: ", response.data);
			}).catch(() => {
				this.$store.commit('navigator/push', {
					extends: Login
				});
			});
		},
		computed: {
			avatar() {
				return this.$getCookie('avatar');
			},
			names() {
				return this.$getCookie('user_names');
			},
			welcomeImage() {
				let localAvatar = this.$getCookie('avatar');
				if(localAvatar){
					return localAvatar;
				}else {
					return "https://"+process.env.VUE_APP_VARIANT+".capecloud.ch/images/placeholder-logo.png";
				}
			},
			compProfilePrivateBlock(){
				return this.profilePrivateBlock;
			}
		},
		methods: {
			goToCPW() {
				let self = this;
				this.$store.commit('navigator/push', {
					extends: ChangePassword,
					data() {
						return {
							id: self.profile.id,
							email: self.profile.email,
							names: self.profile.names,
						}
					}
				});
			},
			goToDashboard() {
				this.$store.commit('navigator/reset');
				this.$store.commit('navigator/push', {
					extends: CollectionsHome
				});
			}
		},
		watch: {
			profile: {
				handler(newProfileVal){
					if(newProfileVal.contact.private_address || newProfileVal.contact.date_of_birth ){
						this.profilePrivateBlock = true;
					}
				},
				deep: true
			}
		}
	}
</script>

<style scoped>
	.left.text {
		min-width: auto !important;
		padding-right: 16px;
		line-height: 1.2em;
		align-items: baseline;
	}
	.qf-user-welcome-avatar {
		margin: 0 auto;
		position: relative;
		display: block;
		overflow: hidden;
	}

	.qf-user-welcome-avatar.rounded {
		width: 100px;
		height: 100px;
		border-radius: 50%;
		border: 3px solid white;
		box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);
	}
	.profile-top{
		margin: 24px 16px;
		text-align: center;
	}
</style>
